import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { HouseCorporateEveningGlobalFieldProps } from '../../form-container/HouseCorporateEveningGlobalFormContainer'
import { HouseCorporateEveningGlobalDto } from '../../../../../../../../../lib/graphql'
import { ControlledTextField } from '../../../../../../../../forms'

export const HouseCorporateEveningGlobalCapacityFields = ({
  control,
  isFieldDisabled,
}: Omit<HouseCorporateEveningGlobalFieldProps, 'currencyArea'>) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: { required: 'Champ requis.' },
    placeholder: '0',
  }

  const { watch } = useFormContext<HouseCorporateEveningGlobalDto>()

  const minCapacity = watch('options.capacity.min')

  return (
    <>
      <ControlledTextField
        {...fieldProps}
        name='options.capacity.min'
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningGlobalFormFields.options.minCapacity'
            defaultMessage=' Nombre <bold>minimum</bold> de participants'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
      />

      <ControlledTextField
        {...fieldProps}
        name='options.capacity.max'
        rules={{
          ...fieldProps.rules,
          validate: (value: string) => {
            // MaxCapacity should be greater than or equal to MinCapacity
            const hasError = Number(value) < minCapacity

            return !hasError
          },
        }}
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningGlobalFormFields.options.maxCapacity'
            defaultMessage=' Nombre <bold>maximum</bold> de participants'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
      />
    </>
  )
}
